import React from 'react'
import MuiPopover, { PopoverProps } from '@mui/material/Popover'

export type { PopoverProps }

export const Popover = (props: PopoverProps) => <MuiPopover {...props} />

export default Popover
